import { Box, Button, Icon, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import { InjectHoverProvider, useHover } from 'modules/core/lib/hoverContext'

import type Schema from 'modules/custom_resources/store/models/customResources/Schema'

function DragAndDrop() {
  const isHover = useHover()

  return <>{isHover && <Icon.Medium icon="drag-and-drop" />}</>
}

interface Props {
  schema: Schema
}

export const Item = observer(({ schema }: Props) => {
  const { navigation } = useNavigation()

  const name = schema.attributes.name

  const actionRoute = () => {
    return navigation.settings.customizations.customTablesId.fullPath({ id: schema.id })
  }

  return (
    <>
      <InjectHoverProvider>
        <Box flexDirection="row" paddingRight="s32" flexGrow>
          <Box justifyContent="center" width="s12">
            <DragAndDrop />
          </Box>
          <Box paddingY="s24" paddingLeft="s16" gap="s8" flexGrow>
            <Text size="300" weight="medium">
              {name}
            </Text>
          </Box>
          <Box justifyContent="center">
            <Button.Router to={actionRoute()} type="secondary" iconName="arrow-right" />
          </Box>
        </Box>
      </InjectHoverProvider>
    </>
  )
})
